<img [ngSrc]="src1" fill [alt]="data?.name" [ngClass]="{active:!isHovered}" />

<img [ngSrc]="src2" fill [alt]="data?.name" [ngClass]="{active:isHovered}" />
